import Vue from 'vue'
import Router from 'vue-router'
import Layout from './views/layout'
Vue.use(Router)

const router = new Router({
  mode: 'history',
  linkActiveClass: 'aa',
  routes: [
    {
      path: '/',
      redirect: '/student/real-time-answers'
    },
    {
      path: '/login',
      name: 'login',
      component: () => import('./views/login')
    },
    // 学生端：左侧导航壳 + 右侧内容（对话与功能页互相替换）
    {
      path: '/student',
      name: 'student',
      component: () => import('./views/student/student-layout'),
      redirect: '/student/real-time-answers',
      meta: {
        requireAuth: true,
        role: 'student'
      },
      children: [
        {
          path: 'real-time-answers',
          name: 'student-real-time-answers',
          component: () => import('./views/student/real-time-answers'),
          meta: { title: '实时问答', isChat: true }
        },
        {
          path: 'search',
          name: 'student-search',
          component: () => import('./views/student/search-conversations'),
          meta: { title: '搜索对话内容', panel: true }
        },
        {
          path: 'dashboard',
          name: 'student-dashboard',
          component: () => import('./views/student/dashboard'),
          meta: { title: '学习总览', panel: true }
        },
        {
          path: 'error-book',
          name: 'student-error-book',
          component: () => import('./views/student/error-book'),
          meta: { title: '错题本', panel: true }
        },
        {
          path: 'homework-correction',
          name: 'student-homework-correction',
          component: () => import('./views/student/homework-correction'),
          meta: { title: '作业批改', panel: true }
        },
        {
          path: 'planning',
          name: 'student-planning',
          component: () => import('./views/student/study-planning'),
          meta: { title: '学习规划', panel: true }
        },
        {
          path: 'practice',
          name: 'student-practice',
          component: () => import('./views/student/practice'),
          meta: { title: '专项练习', panel: true }
        },
        {
          path: 'practice/:errorId',
          name: 'student-practice-error',
          component: () => import('./views/student/practice-error'),
          meta: { title: '错题练习', panel: true }
        },
        {
          path: 'profile',
          name: 'student-profile',
          component: () => import('./views/common/profile'),
          meta: { title: '设备管理', panel: true }
        },
        {
          path: 'preferences',
          name: 'student-preferences',
          component: () => import('./views/student/preferences'),
          meta: { title: '偏好设置', panel: true }
        },
        {
          path: 'preview',
          name: 'student-preview',
          component: () => import('./views/student/preview'),
          meta: { title: '预习', panel: true }
        },
        {
          path: 'review',
          name: 'student-review',
          component: () => import('./views/student/review'),
          meta: { title: '复习', panel: true }
        },
        {
          path: 'improve',
          name: 'student-improve',
          component: () => import('./views/student/improve'),
          meta: { title: '提升', panel: true }
        }
      ]
    },
    // 教师端（工作台预留）
    {
      path: '/teacher',
      name: 'teacher',
      component: Layout,
      redirect: '/teacher/dashboard',
      meta: {
        requireAuth: true,
        role: 'teacher'
      },
      children: [
        {
          path: '/teacher/dashboard',
          name: 'teacher-dashboard',
          component: () => import('./views/teacher/dashboard'),
          meta: { title: '教师工作台' }
        },
        {
          path: '/teacher/profile',
          name: 'teacher-profile',
          component: () => import('./views/common/profile'),
          meta: { title: '个人中心' }
        }
      ]
    },
    // 家长端
    {
      path: '/parent',
      name: 'parent',
      component: Layout,
      redirect: '/parent/dashboard',
      meta: {
        requireAuth: true,
        role: 'parent'
      },
      children: [
        {
          path: '/parent/dashboard',
          name: 'parent-dashboard',
          component: () => import('./views/parent/dashboard'),
          meta: { title: '家长中心' }
        },
        {
          path: '/parent/profile',
          name: 'parent-profile',
          component: () => import('./views/common/profile'),
          meta: { title: '个人中心' }
        }
      ]
    }
  ]
})

export default router
